import {
  Box,
  Stack,
  CircularProgress,
  Typography,
  styled,
} from '@mui/material';

export const StyledDistroSectionContainer = styled(Box)<{ isAnnual: boolean }>(
  ({ theme, isAnnual }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(3),
    minHeight: theme.spacing(50),
    padding: theme.spacing(3),
    [theme.breakpoints.down('desktop')]: {
      minHeight: isAnnual ? theme.spacing(50) : theme.spacing(20),
      padding: theme.spacing(2),
    },
    background: isAnnual ? theme.palette.secondary.darkest : undefined,
    borderTop: isAnnual
      ? `1px solid ${theme.palette.secondary.darkest}`
      : `1px solid ${theme.palette.grey[700]}`,
    borderBottom: isAnnual
      ? `1px solid ${theme.palette.secondary.darkest}`
      : `1px solid ${theme.palette.grey[700]}`,
  })
);

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
}));

export const StyledLoadingContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
  [theme.breakpoints.down('desktop')]: {
    minHeight: theme.spacing(20),
  },
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledLoading = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[400],
}));
